export const SET_FACTOR = "SET_FACTOR";
export const SET_FACTORS = "SET_FACTORS";
export const SET_FACTOR_PATTERN = "SET_FACTOR_PATTERN";
